import { useEffect, useState } from 'react';

export type ThemeChoice = 'system' | 'light' | 'dark';
const key = 'sloplens.theme.v1';

export function readTheme(): ThemeChoice {
  try { const value = localStorage.getItem(key); if (value === 'light' || value === 'dark') return value; } catch { /* Storage can be unavailable; the system preference applies. */ }
  return 'system';
}

export function applyTheme(choice: ThemeChoice) {
  const root = document.documentElement;
  if (choice === 'system') delete root.dataset.theme; else root.dataset.theme = choice;
}

export function useTheme() {
  const [theme, setTheme] = useState<ThemeChoice>(readTheme);
  useEffect(() => {
    applyTheme(theme);
    try { if (theme === 'system') localStorage.removeItem(key); else localStorage.setItem(key, theme); } catch { /* The choice still applies for this visit. */ }
  }, [theme]);
  return [theme, setTheme] as const;
}

/** The theme actually shown, used by the single mobile toggle to pick the opposite one. */
export function resolvedTheme(choice: ThemeChoice): 'light' | 'dark' {
  if (choice !== 'system') return choice;
  // The prerender has no media queries, so it draws the light theme's toggle until the script takes over.
  return typeof matchMedia === 'function' && matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}
